// import React from 'react'
// import {
//     Navbar,
//     NavbarBrand,
//     NavItem,
//     Nav,
    
//   } from "reactstrap";
//   import { NavLink } from "react-router-dom";
//   import 'bootstrap/dist/css/bootstrap.min.css'

// import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
// import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
// import { useStateValue } from './Components/StateProvider';

// function Header() {
//     const [{basket}]=useStateValue();
//     return (
//         <div>
//         <Navbar expand="sm" dark fixed="top">
//           <div className="container">
//             <NavbarBrand>
//               <NavLink to="/" className='carticon ml-auto'><span><ShoppingCartIcon /> UK-Cart </span> 
//                 {/* <img  src="" height="60" width="230" alt='Electura'></img> */}
//               </NavLink>
//             </NavbarBrand>
         
//               <Nav navbar className="navLink">
//                 <NavItem>
//                   <NavLink  className="nav-link text " to="/Electronics">
//                    <span className='hstyle'> Electronics</span>
//                   </NavLink>
//                 </NavItem>
//                 <NavItem>
//                   <NavLink className="nav-link text" to="/Fashion">
//                   <span className='hstyle'> Fashion</span> 
//                   </NavLink>
//                 </NavItem>
//                 {/* <NavItem>
//                   <NavLink className="nav-link text" to="/Itemdetail">
//                   <span className='hstyle'> Detail</span> 
//                   </NavLink>
//                 </NavItem> */}
//                 <NavItem>
//                   <NavLink  className="nav-link text" to="/Cart">
//                   <span className='hstyle'><ShoppingBasketIcon /><span className="basket_count">{basket.length===0?'':basket.length}</span></span>  
//                   </NavLink>
//                 </NavItem>
//               </Nav>
            
//           </div>
//         </Navbar>

     
        
//       </div>
//     )
// }

// export default Header

import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { useStateValue } from './StateProvider';

function Header(){
  const [{basket}]=useStateValue();
    return (
        <div className="vv" >
        <nav className="navbar ll navbar-expand-lg navbar-light">
       <Link className="navbar-brand" exact to={'/'} style={{color:'white'}}><ShoppingCartIcon/>Uk-Cart</Link>
       {/* <a className="navbar-brand" href=""><i class="fab fa-opencart fa-2x"></i>Ucart</a> */}
       <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
     <div className="collapse navbar-collapse" id="navbarSupportedContent">
       <ul className="navbar-nav ml-auto">
         
           <li className="nav-item">
             <div className="link-div">
             <Link className="nav-link" exact to={'/Fashion'}>Fashion</Link>
             </div>
           </li>
           <li className="nav-item"><div className="link-div">
               {/* <a className="nav-link" href="#footer">Electronic</a> */}
               <Link className="nav-link" exact to={'/Electronics'}>Electronic</Link>
               </div>
           </li>
           
           <li className="nav-item">
             <div className="link-div">
               <Link className="nav-link" exact to={"/Cart"}><ShoppingBasketIcon /><span className="basket_count">{basket.length===0?'':basket.length}</span></Link>
               </div> 
           </li>
       </ul>
    </div>
    </nav>
    </div>
      
    );
}
export default Header;
